import { SubClause } from "../ars_ldm";
import { isSubClauseWithCompoundExpression } from "./isSubClauseWithCompoundExpression";
import { isSubClauseWithCondition } from "./isSubClauseWithCondition";
import { isSubClauseWithReference } from "./isSubClauseWithReference";

/**
 * Type guard to check if a value is a SubClause.
 *
 * Validates that the object has only one of:
 * - A non-blank subClauseId
 * - A valid condition
 * - A valid compoundExpression
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClause
 */
export const isSubClause = (obj: unknown): obj is SubClause => {
  return (
    isSubClauseWithCondition(obj) ||
    isSubClauseWithCompoundExpression(obj) ||
    isSubClauseWithReference(obj)
  );
};
